import {
  HeaderBottom,
  HeaderWrapper,
  InnerContainer,
  TextWrapper,
  TitleWrapper,
} from "./styled";
import { Text } from "../../../library/text";
import { useTranslation } from "react-i18next";
import { Title } from "../../../library/title";
import headerBottom from "../../../assets/img/header-bottom.svg";

const Header = () => {
  const { t } = useTranslation();

  return (
    <HeaderWrapper>
      <InnerContainer>
        <TitleWrapper>
          <Title size="xl">Meld deg på webinar</Title>
        </TitleWrapper>
        <TextWrapper>
          <Text color="dark">
            Ønsker du å lære hvordan du kan bruke Randi.ai til å enkelt tekste
            videofilene dine? Null stress, da kan du melde deg på vårt webinar
            nedenfor.
          </Text>
        </TextWrapper>
      </InnerContainer>
      <HeaderBottom
        src={headerBottom}
        alt={t("frontpage.sections.header.bottom-separator.alt")!}
      />
    </HeaderWrapper>
  );
};

export default Header;
